export default __webpack_public_path__ + "static/media/ObjektivMk1_Trial_Rg.464896fa.ttf";